import { notImplemented } from "../../../_internal/utils.mjs";
export { constants } from "../_constants.mjs";
export const access = notImplemented("fs.access");
export const copyFile = notImplemented("fs.copyFile");
export const cp = notImplemented("fs.cp");
export const open = notImplemented("fs.open");
export const opendir = notImplemented("fs.opendir");
export const rename = notImplemented("fs.rename");
export const truncate = notImplemented("fs.truncate");
export const rm = notImplemented("fs.rm");
export const rmdir = notImplemented("fs.rmdir");
export const mkdir = notImplemented("fs.mkdir");
export const readdir = notImplemented("fs.readdir");
export const readlink = notImplemented("fs.readlink");
export const symlink = notImplemented("fs.symlink");
export const lstat = notImplemented("fs.lstat");
export const stat = notImplemented("fs.stat");
export const link = notImplemented("fs.link");
export const unlink = notImplemented("fs.unlink");
export const chmod = notImplemented("fs.chmod");
export const lchmod = notImplemented("fs.lchmod");
export const lchown = notImplemented("fs.lchown");
export const chown = notImplemented("fs.chown");
export const utimes = notImplemented("fs.utimes");
export const lutimes = notImplemented("fs.lutimes");
export const realpath = notImplemented("fs.realpath");
export const mkdtemp = notImplemented("fs.mkdtemp");
export const writeFile = notImplemented("fs.writeFile");
export const appendFile = notImplemented("fs.appendFile");
export const readFile = notImplemented("fs.readFile");
export const watch = notImplemented("fs.watch");
export const statfs = notImplemented("fs.statfs");
export default {};
